export default __webpack_public_path__ + "static/media/picture2-border.23037c95.svg";